import { useEffect } from 'react'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import LeftPanel from 'common/components/leftPanel/LeftPanel'
import Loader from 'common/components/loaders/Loader'
import { errorToast } from 'common/components/toastNotification'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { Add } from 'common/icons'
import useGetMetadataListQuery from 'features/reports/api/queries/useGetMetadataListQuery'
import { selectThoughtspotReport } from 'features/reports/store/reportsSlice'

import ReportCard from './ReportCard'

const LeftSection = () => {
  const dispatch = useAppDispatch()
  const selectedLiveboardId = useAppSelector(
    (state) => state.reports.selectedLiveboardId
  )

  const { data: liveboards, ...metadataListQuery } = useGetMetadataListQuery()

  useEffect(() => {
    if (liveboards?.length) {
      dispatch(selectThoughtspotReport(liveboards[0].id))
    }
  }, [liveboards, dispatch])

  return (
    <LeftPanel mode="solid">
      <Loader
        className="m-auto"
        hasWrapperFullHeight
        isLoading={metadataListQuery.isLoading}
      >
        <div className="flex flex-col gap-4">
          <div className="flex justify-between items-center">
            <p className="uppercase font-medium">Saved reports</p>
            <ButtonWithTooltip
              tooltip
              tooltipText="Add new report"
              prefixIcon={<Add size={4} />}
              onClick={() => errorToast('Not implemented yet')}
            />
          </div>
          <hr className="w-full border-gold-400" />
          {liveboards?.map((liveboard) => (
            <ReportCard
              key={liveboard.id}
              name={liveboard.name}
              createdDate={liveboard.createdDate}
              isSelected={selectedLiveboardId === liveboard.id}
              onClick={() => dispatch(selectThoughtspotReport(liveboard.id))}
            />
          ))}
        </div>
      </Loader>
    </LeftPanel>
  )
}

export default LeftSection
